import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8" data-testid="admin-customers-page">
      <div>
        <div className="eyebrow mb-2">Customers</div>
        <h1 className="font-serif text-4xl font-light">Client directory</h1>
      </div>

      <div className="bg-card border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-muted-foreground">
            <tr>
              <th className="px-5 py-3 eyebrow font-normal">Name</th>
              <th className="px-5 py-3 eyebrow font-normal">Email</th>
              <th className="px-5 py-3 eyebrow font-normal">Phone</th>
              <th className="px-5 py-3 eyebrow font-normal">Bookings</th>
              <th className="px-5 py-3 eyebrow font-normal">Last booking</th>
            </tr>
          </thead>
          <tbody>
            {loading && (<tr><td colSpan={5} className="px-5 py-10 text-center text-muted-foreground">Loading…</td></tr>)}
            {!loading && customers.length === 0 && (<tr><td colSpan={5} className="px-5 py-10 text-center text-muted-foreground">No customers yet.</td></tr>)}
            {customers.map((c) => (
              <tr key={c.email} className="border-t border-border">
                <td className="px-5 py-4">{c.name}</td>
                <td className="px-5 py-4">{c.email}</td>
                <td className="px-5 py-4">{c.phone || "—"}</td>
                <td className="px-5 py-4">{c.booking_count}</td>
                <td className="px-5 py-4">{c.last_booking_at ? new Date(c.last_booking_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
